import { ApiRequestError } from '@/lib/api-client';

/** Mensagens de tela para os `code` de cargo/gestor definidos no contrato da API (docs/organograma-automatico-cargos). */
const MENSAGENS_POR_CODIGO: Record<string, string> = {
  CARGO_INVALIDO: 'Cargo inválido: escolha um cargo ativo desta empresa',
  GESTOR_INVALIDO: 'Gestor precisa ser uma pessoa ativa desta empresa',
  GESTOR_CICLO: 'Esse gestor já responde a esta pessoa',
  EMPRESA_OBRIGATORIA: 'Selecione uma empresa para definir cargo e gestor',
};

/** Usa a mensagem de tela do `code` conhecido; senão, a mensagem do servidor; senão, o texto padrão. */
export function mensagemDoErroCargoGestor(error: unknown, padrao: string): string {
  if (error instanceof ApiRequestError && error.code && MENSAGENS_POR_CODIGO[error.code]) {
    return MENSAGENS_POR_CODIGO[error.code];
  }
  return error instanceof Error ? error.message : padrao;
}
